import { useState } from 'react';
import { Box, Popover, Chip, CircularProgress, useMediaQuery } from '@mui/material';
import ChecklistIcon from '@mui/icons-material/PlaylistAddCheck';
import SetupChecklist from 'components/SetupChecklist';
import useSetupProgress from 'hooks/useSetupProgress';
import { useTheme } from '@mui/material/styles';

export default function SetupProgressButton() {
  const [anchorEl, setAnchorEl] = useState(null);
  const downSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const { progress, loading } = useSetupProgress();

 

  // Hide once everything is complete
  if (!progress || progress.percent >= 100) return null;

  const open = Boolean(anchorEl);

   
return (
    <Box>
      <Chip
        icon={<ChecklistIcon sx={{ color: `${'primary.main'} !important` }} />}
        label={downSM ? `${progress.percent}%` : `Setup ${progress.percent}%`}
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        clickable
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'primary.main',
          color: 'primary.main',
          fontWeight: 600,
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ p: 2, width: 320 }}>
          <SetupChecklist onNavigate={() => setAnchorEl(null)} />
        </Box>
      </Popover>
    </Box>
  );
}
